import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'

export const ASSETCLASSES = [
  'AGF',
  'AMC',
  'Alternative',
  'Asset Swap',
  'Benchmark',
  'CDSHedge',
  'Commodity',
  'Commodity Volatility',
  'Common Stock',
  'Credit',
  'Cross-Asset',
  'DGF',
  'Diversifier',
  'Equity',
  'European Equity Vol Arb',
  'FX',
  'Gold',
  'Growth',
  'Hedge Fund',
  'Income',
  'Property',
  'PutHedge',
  'Rate',
  'Rates',
  'SPTR Index',
  'US Equity Vol Arb',
] as const

export type Assetclass = (typeof ASSETCLASSES)[number]

export const ASSETCLASS_OPTIONS = sortAlphabeticallyByKey(
  ASSETCLASSES.map((a) => ({ label: a, value: a })),
  'label',
)
